
export default function ZEaser(frame, finish, options) {
        this._finishFn = finish;
	if (!options.easing) {
    		options.easing = Animator.bezier(0.25, 0.1, 0.25, 1);
	}
	this._finishEase = function() {
		delete this._abortFn;
		// The finish function might emit events which trigger new eases, which
		// set a new _finishFn. Ensure we don't delete it unintentionally.
		var finish = this._finishFn;
		delete this._finishFn;
		finish.call(this);
	}
	this.stop = function() {
		if (this._abortFn) {
			this._abortFn.call(this);
			this._finishEase();
		}
		return this;
	}
	this._abortFn = Animator.timed(function (t) {
		frame.call(this, options.easing(t));
		if (t === 1) {
			this._finishEase();
		}
	}, options.animate === false ? 0 : options.duration, this);
}
	
var Animator = {
	bezier: function(p1x, p1y, p2x, p2y) {
		var bezier = new UnitBezier(p1x, p1y, p2x, p2y);
		return function(t) {
			return bezier.solve(t);
		};
	},
	framed: (window.requestAnimationFrame ||
    		window.mozRequestAnimationFrame ||
    		window.webkitRequestAnimationFrame ||
    		window.msRequestAnimationFrame).bind(window),

	frame: function(fn) { return Animator.framed(fn); },

	canceled: window.cancelAnimationFrame ||
    		window.mozCancelAnimationFrame ||
    		window.webkitCancelAnimationFrame ||
    		window.msCancelAnimationFrame,

	cancel: function(id) { Animator.canceled(id); },

	timed: function (fn, dur, ctx) {
	    if (!dur) {
	        fn.call(ctx, 1);
	        return null;
	    }

	    var abort = false,
	        start = window.performance ? window.performance.now() : Date.now();

	    function tick(now) {
	        if (abort) return;
	        if (!window.performance) now = Date.now();
	
	        if (now >= start + dur) {
	            fn.call(ctx, 1);
	        } else {
	            fn.call(ctx, (now - start) / dur);
	            Animator.frame(tick);
	        }
	    }

	    Animator.frame(tick);

	    return function() { abort = true; };
	}
};

function UnitBezier(p1x, p1y, p2x, p2y) {
    // Calculate the polynomial coefficients, implicit first and last control points are (0,0) and (1,1).
    this.cx = 3.0 * p1x;
    this.bx = 3.0 * (p2x - p1x) - this.cx;
    this.ax = 1.0 - this.cx - this.bx;

    this.cy = 3.0 * p1y;
    this.by = 3.0 * (p2y - p1y) - this.cy;
    this.ay = 1.0 - this.cy - this.by;

    this.p1x = p1x;
    this.p1y = p2y;
    this.p2x = p2x;
    this.p2y = p2y;
}

UnitBezier.prototype.sampleCurveX = function(t) {
    // `ax t^3 + bx t^2 + cx t' expanded using Horner's rule.
    return ((this.ax * t + this.bx) * t + this.cx) * t;
};

UnitBezier.prototype.sampleCurveY = function(t) {
    return ((this.ay * t + this.by) * t + this.cy) * t;
};

UnitBezier.prototype.sampleCurveDerivativeX = function(t) {
    return (3.0 * this.ax * t + 2.0 * this.bx) * t + this.cx;
};

UnitBezier.prototype.solveCurveX = function(x, epsilon) {
    if (typeof epsilon === 'undefined') epsilon = 1e-6;

    var t0, t1, t2, x2, i;

    // First try a few iterations of Newton's method -- normally very fast.
    for (t2 = x, i = 0; i < 8; i++) {

        x2 = this.sampleCurveX(t2) - x;
        if (Math.abs(x2) < epsilon) return t2;

        var d2 = this.sampleCurveDerivativeX(t2);
        if (Math.abs(d2) < 1e-6) break;

        t2 = t2 - x2 / d2;
    }

    // Fall back to the bisection method for reliability.
    t0 = 0.0;
    t1 = 1.0;
    t2 = x;

    if (t2 < t0) return t0;
    if (t2 > t1) return t1;

    while (t0 < t1) {

        x2 = this.sampleCurveX(t2);
        if (Math.abs(x2 - x) < epsilon) return t2;

        if (x > x2) {
            t0 = t2;
        } else {
            t1 = t2;
        }

        t2 = (t1 - t0) * 0.5 + t0;
    }

    // Failure.
    return t2;
};

UnitBezier.prototype.solve = function(x, epsilon) {
    return this.sampleCurveY(this.solveCurveX(x, epsilon));
};






// WEBPACK FOOTER //
// ./src/zeaser.js